import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Search: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon=Search">
      <path
        id="Vector"
        d="M15 15.0002L21 21.0002M10 17.0002C6.13401 17.0002 3 13.8662 3 10.0002C3 6.13425 6.13401 3.00024 10 3.00024C13.866 3.00024 17 6.13425 17 10.0002C17 13.8662 13.866 17.0002 10 17.0002Z"
        stroke="currentColor"
        strokeWidth="currentStrokeWidth"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Search;
